import { render } from "./Loading.vue?vue&type=template&id=062c8058&scoped=true"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"

import "./Loading.vue?vue&type=style&index=0&id=062c8058&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-062c8058"

export default script